import {
  NETWORK_ERROR,
  SET_NETWORK_ERROR_NOTIFICATION,
  REMOVE_NETWORK_ERROR_NOTIFICATION,
} from '../actions/constants';

const defaultState = {
  status: null,
  origin: {},
};

const networkErrorReducer = (state = defaultState, action) => {
  switch (action.type) {
    case NETWORK_ERROR: {
      return {
        ...state,
        status: action.status,
      };
    }
    case SET_NETWORK_ERROR_NOTIFICATION: {
      return {
        ...state,
        origin: {
          ...state.origin,
          [action.origin]: action.id,
        },
      };
    }
    case REMOVE_NETWORK_ERROR_NOTIFICATION: {
      return {
        ...state,
        origin: {
          ...state.origin,
          [action.origin]: null,
        },
      };
    }
    default:
      return state;
  }
};

export default networkErrorReducer;
